<div class="card-container">
    <div>
        <kendo-card class="card" style="width: 100%" (click)="openCloudFlow4InvoiceUrl()">
            <kendo-card-body>
                <div class="square-img-box">
                    <img src="../../../assets/img/efactura-smarttax.jpg" />
                </div>
                <div class="cardtxt">
                    <h3>{{ 'home.cardInvoice.title' | translate }}</h3>
                    <p>
                        {{ 'home.cardInvoice.paragraph-1' | translate }}
                    </p>
                    <ul class="lst">
                        <li>
                            <i class="fa fa-check liitem" aria-hidden="true"></i>
                            {{ 'home.cardInvoice.bullet-1' | translate }}
                        </li>
                        <li>
                            <i class="fa fa-check liitem" aria-hidden="true"></i>
                            {{ 'home.cardInvoice.bullet-2' | translate }}
                        </li>
                    </ul>
                </div>
            </kendo-card-body>
            <hr kendoCardSeparator />
            <kendo-card-actions layout="end">
                <button kendoButton fillMode="flat" themeColor="primary" class="btnGo" (click)="openCloudFlow4InvoiceUrl()">
                    {{ 'home.cardInvoice.link' | translate }}
                    <kendo-icon name="arrow-chevron-right" [style.marginLeft.px]="7"></kendo-icon>
                </button>
            </kendo-card-actions>
        </kendo-card>
    </div>
    <div>
        <kendo-card class="card" style="width: 100%" (click)="openCloudFlow4TransUrl()">
            <kendo-card-body>
                <div class="square-img-box">
                    <img src="../../../assets/img/etransport-ecmr.jpg" />
                </div>
                <div class="cardtxt">
                    <h3>{{ 'home.cardTransport.title' | translate }}</h3>
                    <p>{{ 'home.cardTransport.paragraph-1' | translate }}</p>
                    <ul class="lst">
                        <li>
                            <i class="fa fa-check liitem" aria-hidden="true"></i>
                            {{ 'home.cardTransport.bullet-1' | translate }}
                        </li>
                        <li>
                            <i class="fa fa-check liitem" aria-hidden="true"></i>
                            {{ 'home.cardTransport.bullet-2' | translate }}
                        </li>
                        <li>
                            <i class="fa fa-check liitem" aria-hidden="true"></i>
                            {{ 'home.cardTransport.bullet-3' | translate }}
                        </li>
                    </ul>
                </div>
            </kendo-card-body>
            <hr kendoCardSeparator />
            <kendo-card-actions layout="end">
                <button kendoButton fillMode="flat" themeColor="primary" class="btnGo" (click)="openCloudFlow4TransUrl()">
                    {{ 'home.cardTransport.link' | translate }}
                    <kendo-icon name="arrow-chevron-right" [style.marginLeft.px]="7"></kendo-icon>
                </button>
            </kendo-card-actions>
        </kendo-card>
    </div>
</div>
